import { Space, Tabs as AntdTabs, type TabsProps } from 'antd';
import { PageHeader } from 'components';
import type { VFC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ShoppingCartTab } from './const';

import { HardwareListRouter } from './tabs/hardware-list/Router';

const { TabPane } = AntdTabs;

export const Page: VFC = () => {
  const history = useHistory();
  const { tab = ShoppingCartTab.HardwareList } = useParams<{ tab: ShoppingCartTab }>();

  const handleTabChange: TabsProps['onChange'] = (activeTab: ShoppingCartTab) => {
    history.push(`/reseller-data/hardwares/${activeTab}`);
  };

  return (
    <Space className="w-100" direction="vertical">
      <PageHeader ghost={false} title="Hardware List" />

      <AntdTabs
        activeKey={tab}
        size="small"
        tabBarStyle={{ paddingLeft: 24, backgroundColor: 'white' }}
        onChange={handleTabChange}
      >
        <TabPane key={ShoppingCartTab.HardwareList} tab="Hardware List">
          <HardwareListRouter />
        </TabPane>
        <TabPane key={ShoppingCartTab.Versions} disabled tab="Versions" />
        <TabPane key={ShoppingCartTab.Settings} disabled tab="Settings" />
      </AntdTabs>
    </Space>
  );
};
